import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog,MatCheckboxChange} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { getSpaceCategory, getTemplates, loadTemplateDevice, addTemplateSpace } from '../../../technologyoverlay';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage, } from '../../../../../app-general';
import { Router} from '@angular/router';
import { NewDeviceTypeDesc, DeviceTypeDesc, DeviceType, appsettings} from '../../../../../app-settings';
import { ApiService } from '../../../../../api.service';
import { getCampus, getBuilding, getZone } from '../../../../../api';

@Component({
  selector: 'app-insert-template',
  templateUrl: './insert-template.component.html',
  styleUrls: ['./insert-template.component.scss']
})
export class InsertTemplateComponent implements OnInit {

  public addTempateForm : FormGroup;
  public floorTempateForm : FormGroup;
  selectedTempId;
  FloorInfo;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  SpaceInfo;
  watcher: Subscription;  
  firstcolumns = 2;  
  columns: number = 4;
  rowHeight = "65px";
  checkfloorinfo = false;  
  Templatedetails;
  Tempflag = 0;
  Campusdetails;
  Buildingdetails;
  Floordetails;
  selectedCampusId;
  selectBuildId;
  selectFloorId;
  selTemp_Id;
  Spacecategory_details;
  selectCategoryId;
  DevicesInfo;
  selectedFloorid;
  select_DeviceIds = [];
  selectedmapdata;
  selectTemplateId = 0;
  floorrowHeight = "79px";
  checkResOffLimits = false;
  templatecheckSpaceCategory = 0;  
  checkSpaceCategory = 0;     
  _roomenablehourmin = false;
  _roomenableroomallday = false;
  checkresroominfo = false;
  public Curfew_data = [];
  data_RstartTime;
  data_RendTime;
  
  public EnumDeviceType = DeviceType;
  
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<InsertTemplateComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService, public dialog: MatDialog,private apiService: ApiService) { 
    this.getCurfew_data();
    this.selectedFloorid = data.FloorId;
    this.selectedmapdata = data;
    this.selectedCampusId = data.CampusId;
    this.selectBuildId = data.BuildId;
    this.selectFloorId = data.FloorId;
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {          
          this.firstcolumns = 1; 
          this.columns = 2;                             
        } 
        else if (change.mqAlias == 'sm') {          
          this.firstcolumns = 2;  
          this.columns = 2;               
        }  
        else if (change.mqAlias == 'md') {          
          this.firstcolumns = 2; 
          this.columns = 2;  
        }               
       else
       {         
         this.firstcolumns = 2;
         this.columns = 4;                             
       }
      }
    
    });
  }
  
  getCurfew_data()
  {
    var _curfewdata={};
    var _curfew_data_arr = [];
    var hourtext = "";
    var _hour = "";
    var _min="";
    var min_inc=30;
    for(var hour = 0; hour <= 24; hour++) 
    {  
      if(hour < 12)
      {
        _hour = "0" + hour.toString();
        hourtext = " am";
      }
      else if(hour == 24)
      {
          _hour =  (hour-12).toString();
          hourtext = " am";
          min_inc=60;
      }   
      else if(hour > 12)
      {
        _hour = "0" + (hour-12).toString();
          hourtext = " pm";
      }    
      else if(hour == 12)
      {
          _hour = hour.toString();
          hourtext = " pm";
      }   
      
      _hour= _hour.slice(-2);
      for(var min = 0; min < 60; min=min+min_inc)
      {     
        _min = "0" + min.toString();  
        _min= _min.slice(-2);               
        _curfewdata = {Time:_hour + ":" + _min + hourtext, Value: hour + ":" + min }         
        _curfew_data_arr.push(_curfewdata);         
      }
      
    }   
        this.Curfew_data=_curfew_data_arr;     
  }

  ngOnInit() {
    
    this.addTempateForm = new FormGroup({    
      campusname:new FormControl(''),
      buildingname:new FormControl(''), 
      zonename:new FormControl(''), 
      templates:new FormControl('',[Validators.required]),
      newtempname: new FormControl('',[Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      category: new FormControl('',[Validators.required]),
      description: new FormControl('',[Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      res_start: new FormControl(''),
      res_end: new FormControl(''), 
    })     
    this.addTempateForm.get('campusname').disable();             
    this.addTempateForm.get('buildingname').disable(); 
    this.addTempateForm.get('zonename').disable();
    
    this.getCampusDetails();    
    this.getTemplates();
    this.getSpaceCategory();    
  }
  
getCampusDetails()
{
  try
    {
      let campusid: getCampus = {
        siteId : this.SiteId,
        authKey: localStorage.getItem("Authkey")
      }
      this.apiService.getCampusDetails(campusid).pipe(takeUntil(this._onDestroy))
      .subscribe((CampusDetails : any[])=>{  
        this.Campusdetails = CampusDetails["apiReturn"];
        this.getBuildingdetails(this.selectedCampusId)      
      });  
    }
    catch (err) {
      throw new Error('insert-template.component.ts' + ' - getCampusDetails() - ' + err.message);
    }
}  

getBuildingdetails(CampusId)
{
  try
  {
    
    let buildingid: getBuilding = {      
      siteId : this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      campusId :  parseInt(CampusId)
    }
    this.apiService.getBuildingDetails(buildingid).pipe(takeUntil(this._onDestroy))
    .subscribe((BuildingDetails : any[])=>{
      this.Buildingdetails = BuildingDetails["apiReturn"];
      
      this.getZonedetails(this.selectBuildId)
    });  
  }
  catch (err) {
    throw new Error('insert-template.component.ts' + ' - getBuildingdetails() - ' + err.message);
  }
}

getZonedetails(BuildingId)
  {  
    try
    {      
      let floorid: getZone = {
        siteId : this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        campusId:this.selectedCampusId,
        buildId : BuildingId,
        floorId : 0
      }
      this.apiService.getZoneDetails(floorid).pipe(takeUntil(this._onDestroy))
      .subscribe((FloorDetails : any[])=>{
        this.Floordetails = FloorDetails["apiReturn"];
      });  
    }
    catch (err) {
      throw new Error('insert-template.component.ts' + ' - getZonedetails() - ' + err.message);
    }

  }
 
getTemplates()
{
  try
  {
    let template_data = [];
    var spaceitem : getTemplates = 
    {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey")
    }
    this.technologyoverlayService.getTemplates(spaceitem).pipe(takeUntil(this._onDestroy))
    .subscribe((TempDetails: any[]) => {     
      TempDetails.forEach(function(e){   
        if(e.TemplateCategoryId == 2)
        {
          template_data.push(e);
        }
        })
        
        this.Templatedetails = template_data;                            
    });
  }
  catch (err) {
    throw new Error('insert-template.component.ts' + ' - getTemplates() - ' + err.message);
  }
}
  
getSpaceCategory()
{
  try
  {
    var spaceitem : getSpaceCategory = 
    {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"), 
      categoryId: 0
    }
    this.technologyoverlayService.getSpaceCategory(spaceitem).pipe(takeUntil(this._onDestroy))
    .subscribe((spacedetails: any[]) => {
      this.Spacecategory_details = spacedetails;                           
    });
  }
  catch (err) {
    throw new Error('insert-template.component.ts' + ' - getSpaceCategory() - ' + err.message);
  }
}

loadTemplatesForDevice(TempId)
{
  try
  {
    this.DevicesInfo = [];
    let voiceLicense = localStorage.getItem("voice_license");
    let loadTempdevice : loadTemplateDevice =  
    { 
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      templateId: parseInt(TempId), 
      templateCategory : 2,
      isNeedIntercom : parseInt(voiceLicense)
    }
    this.technologyoverlayService.loadTemplatesForDevice(loadTempdevice).pipe(takeUntil(this._onDestroy))
      .subscribe((DeviceDetails: any[]) => {
      
      DeviceDetails.forEach(function (e) {
                
        if (e.DeviceName == DeviceTypeDesc.Emitter) {
          e['NewDeviceName'] = NewDeviceTypeDesc.Emitter;
        }
        else if (e.DeviceName == DeviceTypeDesc.HRex) {
          e['NewDeviceName'] = NewDeviceTypeDesc.HRex;
        }
        else if (e.DeviceName == DeviceTypeDesc.Rex) {
          e['NewDeviceName'] = NewDeviceTypeDesc.Rex;
        }
        else if (e.DeviceName == DeviceTypeDesc.LF) {
          if (e.SubType==DeviceType.DripTray)
          {
            e['NewDeviceName'] = NewDeviceTypeDesc.DripTray;
          }
          else
          {
            e['NewDeviceName'] = NewDeviceTypeDesc.LFExiter;
          }
        }
        else if (e.DeviceName == DeviceTypeDesc.Pullcord) {
          e['NewDeviceName'] = NewDeviceTypeDesc.Pullcord;
        }
        else if (e.DeviceName == DeviceTypeDesc.DC || e.DeviceName == DeviceTypeDesc.NewDC) {
          e['NewDeviceName'] = NewDeviceTypeDesc.DC;
        }
        else if (e.DeviceName == DeviceTypeDesc.Monitor) {
          e['NewDeviceName'] = NewDeviceTypeDesc.Monitor;
        }
        else if (e.DeviceName == DeviceTypeDesc.VW) {
          e['NewDeviceName'] = NewDeviceTypeDesc.VW;
        }
        else if (e.DeviceName == DeviceTypeDesc.Gateway) {
          e['NewDeviceName'] = NewDeviceTypeDesc.Gateway;
        }
        else if (e.DeviceName == DeviceTypeDesc.UT ) { 
          e['NewDeviceName'] =  NewDeviceTypeDesc.UT;
        }
        else if (e.DeviceName == DeviceTypeDesc.UM ) { 
          e['NewDeviceName'] =  NewDeviceTypeDesc.UM;
        }
        else if (e.DeviceName == DeviceTypeDesc.Intercom ) { 
          e['NewDeviceName'] =  NewDeviceTypeDesc.Intercom;
        }
        else if(e.DeviceTypeId == DeviceType.Room)
        {
          e['NewDeviceName'] = NewDeviceTypeDesc.Room;
        }
        else {
        //  e['NewDeviceName'] = NewDeviceTypeDesc.Zone;
        }
      })
      if (DeviceDetails[0].DataId!=null)
      {
        this.DevicesInfo = DeviceDetails;     
      }
      else
      { //dont show the select all check box if not devices then
        this.selectTemplateId=0;
        this.DevicesInfo =[];
      }
    });
  }
  catch (err) {
    throw new Error('insert-template.component.ts' + ' - loadTemplatesForDevice() - ' + err.message);
  }
}
  
handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.addTempateForm.controls).forEach(field => { // {1}
        const control = this.addTempateForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-template.component.ts' + ' - handleInput() - ' + err.message);
    }
}

public onCloseCancel = () => {   
  this.thisDialogRef.close('Cancel');
  if(!SessionCheck(this.router))
  {
      return;
  }
  
}

selectTempCategory(tempId)
{       
  this.selectTemplateId = tempId; 
  this.loadTemplatesForDevice(tempId);      
} 

selectSpaceCategory(categoryId)
{       
 
  this.selectCategoryId = categoryId;         
} 

isCheckedAll = false;
toggleAll(event: MatCheckboxChange) {

  if (event.checked) {
    this.select_DeviceIds = [];
    this.DevicesInfo.forEach(row => {
      var checkedid = row.DataId
      this.select_DeviceIds.push(checkedid)
    });

  } else {
    
    this.select_DeviceIds = [];
    this.select_DeviceIds.length = 0;
  }
  this.isCheckedAll = this.isChecked();
}

toggleUnitVisibility(checkedid, event: MatCheckboxChange) 
{ 

  if (event.checked) {
    const index = this.select_DeviceIds.indexOf(checkedid);
    if (index == -1) {
      this.select_DeviceIds.push(checkedid);
    }
  } else {
    const index = this.select_DeviceIds.indexOf(checkedid);
    if (index >= 0) {
      this.select_DeviceIds.splice(index, 1);
    }
  }
  this.isCheckedAll = this.isChecked();
  

}
exists(checkedid) {
  return this.select_DeviceIds.indexOf(checkedid) > -1;
};

isChecked() {
  return this.select_DeviceIds.length === this.DevicesInfo.length;
};

public addtemplateDetails = (addtemplateformvalue) => 
  {

    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur(); 
      if (this.addTempateForm.valid) { 
        let saveclick = document.getElementById('btnsavetempaddclick');
            saveclick.className = 'clstempsavebutton mat-raised-button disablebtn';
          this.addTemplateSpace(addtemplateformvalue)
      }
    }
    catch(err)
    {
      throw new Error('template-floor.component.ts' + ' - templatefloorDetails() - ' + err.message);
    }
  }
  
addTemplateSpace(insertTempform)
{
  try
    {
        var resofflimits = 0;
        var check_Room_AllDay;        
        var resstarttime, resendtime;        
        var res_Start_Hr, res_Start_Min;
        var res_End_Hr, res_End_Min;        
        let saveclick = document.getElementById('btnsavetempaddclick');
        if(this.select_DeviceIds.length == 0 && this.DevicesInfo.length > 0)
        {
          generateAlertMessage(this.dialog, 'Must add at least one Device to create as a new Space Template.');           
          saveclick.className = 'clstempsavebutton mat-raised-button';  
          return;                  
        }
        if(this.select_DeviceIds.length == 0 && this.DevicesInfo.length == 0)
        {
          generateAlertMessage(this.dialog, "Must add at least one Device to duplicate or create as a Template.");    
          saveclick.className = 'clstempsavebutton mat-raised-button';     
          return;
        }      
        saveclick.className = 'clstempsavebutton mat-raised-button disablebtn';
        
        let _Description = "";        
        if(insertTempform.description != "")
          _Description = insertTempform.description.replace(/\s+/g, ' ').trim();
        else
          _Description = "";
          
        if(this.checkResOffLimits == true)
          resofflimits = 1;
        else
          resofflimits = 0;       
          
          if(insertTempform.res_start != undefined && insertTempform.res_start != 0)
          {
            resstarttime = insertTempform.res_start.split(":");
            res_Start_Hr = parseInt(resstarttime[0]);
            res_Start_Min = resstarttime[1].split(" ");        
            res_Start_Min = parseInt(res_Start_Min[0]);
          }
          if(insertTempform.res_end != undefined && insertTempform.res_end != 0)
          {
            resendtime = insertTempform.res_end.split(":");        
            res_End_Hr = parseInt(resendtime[0]);
            res_End_Min = resendtime[1].split(" ");        
            res_End_Min = parseInt(res_End_Min[0]);
          }
              
          if(this.checkresroominfo == true)        
            check_Room_AllDay = 1;
          else
            check_Room_AllDay = 0;
          
          if(resofflimits == 1)  
          {
            if ((insertTempform.res_start == "" || insertTempform.res_start == undefined) && (insertTempform.res_end == "" ||
            insertTempform.res_end == undefined) && (this.checkresroominfo == false || this.checkresroominfo == undefined)) 
            {              
              generateAlertMessage(this.dialog,"Please select Resident Time info or All");
              saveclick.className = 'clstempsavebutton mat-raised-button';                
              return false;
            }

            if (insertTempform.res_start != "" && insertTempform.res_start != undefined) 
            {
              if (insertTempform.res_end == "" || insertTempform.res_end == undefined) 
              {                
                generateAlertMessage(this.dialog,"Please select Resident End time");
                saveclick.className = 'clstempsavebutton mat-raised-button';                   
                return false;
              }
            }

            if (insertTempform.res_end != "" && insertTempform.res_end != undefined) 
            {
              if (insertTempform.res_start == "" || insertTempform.res_start == undefined) 
              {                
                generateAlertMessage(this.dialog,"Please select Resident Start time");
                saveclick.className = 'clstempsavebutton mat-raised-button';                   
                return false;
              }
            }
          }
          
          // if(resofflimits == 1 && check_Room_AllDay == 0 && res_Start_Hr >= 0 && res_End_Hr < res_Start_Hr )  
          // {
          //   generateAlertMessage(this.dialog,"Start time should be lesser than the End time");
          //   saveclick.className = 'clstempsavebutton mat-raised-button';               
          //   return false;
          // }  
          // else if(resofflimits == 1 && check_Room_AllDay == 0 && res_Start_Hr == res_End_Hr && res_Start_Min >= res_End_Min) 
          // {
          //   generateAlertMessage(this.dialog,"Start time should be lesser than the End time");
          //   saveclick.className = 'clstempsavebutton mat-raised-button';               
          //   return false;
          // }

      let templateadd: addTemplateSpace = {
        siteId:this.SiteId,
        authKey:localStorage.getItem("Authkey"),
        templateId:this.selectTemplateId,
        campusId:parseInt(this.selectedmapdata.CampusId),
        buildingId:parseInt(this.selectedmapdata.BuildId),
        floorId:parseInt(this.selectedmapdata.FloorId),
        newSpaceName:insertTempform.newtempname.replace(/\s+/g, ' ').trim(),
        newSpaceDescription:_Description,//insertTempform.description,
        newSpaceCategoryId:this.selectCategoryId.toString(),
        deviceIds:this.select_DeviceIds.toString(),
        residentOffLimits:resofflimits,
        chkAllday : check_Room_AllDay,
        resStartHr : res_Start_Hr,
        resStartMi : res_Start_Min,
        resEndHr : res_End_Hr,
        resEndMi : res_End_Min
      }
      
      this.technologyoverlayService.addTemplateSpace(templateadd).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: any[]) => 
      { 
        
          if(apiresponse["UnitId"] > 0)
          {
            generateAlertMessage(this.dialog, 'Space added successfully.');       
            this.thisDialogRef.close(apiresponse); 
            this.select_DeviceIds = [];
          }
          if(apiresponse.length > 0)
          {
            generateAlertMessage(this.dialog, "Space name '" + apiresponse[0].UnitName + "' already exists.");        
            saveclick.className = 'clstempsavebutton mat-raised-button';
          }
          else if(apiresponse.toString() == "false")
          {
            generateAlertMessage(this.dialog, 'Space added failed.');       
            this.thisDialogRef.close("close"); 
          }
      })
    }    
    catch(err)
    {
      throw new Error('insert-template.component.ts' + ' - addTemplateSpace() - ' + err.message);
    }
}

toggler_TempResOffLimits(e) {    
  if (e.checked == true) {
    this.checkResOffLimits=true;  
    this.checkresroominfo = true;
    this._roomenableroomallday = true; 
    if(this.checkresroominfo == true)
      this._roomenablehourmin = false;     
    else
      this._roomenablehourmin = true;              
  }
  else{
    this.checkResOffLimits=false;   
    this._roomenableroomallday = false;
    this._roomenablehourmin = false;  
    this.data_RstartTime = 0;
    this.data_RendTime = 0;
    this.checkresroominfo = false;
  }  
  
}

toggleresdayinfoTempVisibility(event)
{
  if (event.checked == true) {
    this._roomenablehourmin = false;     
    this.checkresroominfo = true;
    this.data_RstartTime = "";
    this.data_RendTime = "";
  }
  else{
    this._roomenablehourmin = true;            
    this.data_RstartTime = 0;
    this.data_RendTime = 0;
    this.checkresroominfo = false;
  }
}


}
